import { Fragment } from 'react';
import { AuditEntityLink } from 'components/common/audit-logs/components/audit-entity-link';
import type { TAuditMessageSegment } from 'components/common/audit-logs/services/types.ts';
import { TripStatusTag } from 'components/trips/trip-status-tag';
import styles from './audit-message.module.scss';
import type { IAuditMessageProps } from './types.ts';

export const AuditMessage: React.FC<IAuditMessageProps> = (props) => {
  const { segments } = props;

  const renderSegment = (segment: TAuditMessageSegment) => {
    switch (segment.type) {
      case 'entity':
        return <AuditEntityLink reference={segment.reference} />;
      case 'tripStatus':
        return <TripStatusTag className={styles.status} status={segment.status} />;
      default:
        return <span>{segment.text}</span>;
    }
  };

  return (
    <>
      {segments.map((segment, index) => (
        <Fragment key={index}>
          {renderSegment(segment)}
          {index < segments.length - 1 ? ' ' : null}
        </Fragment>
      ))}
    </>
  );
};
